export default "__VITE_ASSET__CgtOXLJw__"